import utils from '@/utils/utils'
export default{
  install(Vue){

    Vue.prototype.$customSort = function(items, index, isDesc){
      items.sort((a,b) => {

        if(utils.isNull(a[index])){
          a[index] = ''
        }

        if(utils.isNull(b[index])){
          b[index] = ''
        }

        if (!utils.isNull(index[0]) && index[0].indexOf('date') > -1) {

          let a_splitDateTime
          let a_splitDate
          let a_date

          let b_splitDateTime
          let b_splitDate
          let b_date

          if(a[index] == ''){
            // sort을 위해 값이 없으면 가장 낮은 값으로 초기화
            a_date  = new Date('1900-01-01')
          }else{
            a_splitDateTime = a[index].split(' ')
            a_splitDate = a_splitDateTime[0].split('/')
            a_date = new Date(a_splitDate[2] + '-' + a_splitDate[1] + '-' + a_splitDate[0])
          }

          if(b[index] == ''){
            // sort을 위해 값이 없으면 가장 낮은 값으로 초기화
            b_date  = new Date('1900-01-01')
          }else{
            b_splitDateTime = b[index].split(' ')
            b_splitDate = b_splitDateTime[0].split('/')
            b_date = new Date(b_splitDate[2] + '-' + b_splitDate[1] + '-' + b_splitDate[0])
          }

          if (!isDesc[0]) {
            return b_date - a_date
          } else {
            return a_date - b_date
          }
        } else {
          // Application No 정렬
          let appNoCheck = /^[A-Z]{2}\/[A-Z]{1}\/\d{4}\/\d+$/
          if(appNoCheck.test(a[index])){
            let a_idx = a[index].substring(0, 9) + utils.lpad(a[index].substring(10), 4, '0')
            let b_idx = b[index]

            if(!utils.isNull(b[index]) && appNoCheck.test(b[index])){
              b_idx = b[index].substring(0, 9) + utils.lpad(b[index].substring(10), 4, '0')
            }

            if (!isDesc[0]) {
              return a_idx.toLowerCase().localeCompare(b_idx.toLowerCase())
            }
            else {
              return b_idx.toLowerCase().localeCompare(a_idx.toLowerCase())
            }
          }else{
            if(typeof a[index] == 'number'){
              if (!isDesc[0]) {
                return a[index] - b[index]
              }
              else {
                return b[index] - a[index]
              }
            }else{
              if (!isDesc[0]) {
                return a[index].toLowerCase().localeCompare(b[index].toLowerCase())
              }
              else {
                return b[index].toLowerCase().localeCompare(a[index].toLowerCase())
              }
            }
          }
        }
      })
      return items
    }
  }
}